import { useQuery } from "@tanstack/react-query";
import { api } from "../../../../singleton/axios";

export interface AnalystPriceTargetsData {
  symbol: string;
  targetHigh: number;
  targetLow: number;
  targetConsensus: number;
  targetMedian: number;
  currentPrice: number;
}

export function useAnalystPriceTargets(symbol: string | undefined) {
  return useQuery<AnalystPriceTargetsData, Error>({
    queryKey: ["analystPriceTargets", symbol],
    queryFn: async () => {
      if (!symbol) throw new Error("Symbol is required");

      const { data } = await api.get<AnalystPriceTargetsData>(
        "/analyst-price-targets",
        {
          params: { symbol },
        }
      );
      return data;
    },
    enabled: !!symbol,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 30 * 60 * 1000, // Keep in cache for 30 minutes
    retry: (failureCount, error) => {
      // Don't retry on 404s - no price target data exists for this stock
      if ((error as any)?.response?.status === 404) return false;
      return failureCount < 2;
    },
  });
}
